export default __webpack_public_path__ + "static/media/mascot.874dd7a0.png";